var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.BaseMenu,{attrs:{"nav-menu-items":_setup.navMenuItems}}),_c('button',{staticClass:"tw-absolute tw-left-[74px] tw-top-0 tw-z-[11] tw-h-[64px] tw-py-2",on:{"click":function($event){$event.stopPropagation();return _setup.goHome.apply(null, arguments)}}},[_c(_setup.LogosMap)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }